import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=cbda3d7e&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbda3d7e')) {
      api.createRecord('cbda3d7e', component.options)
    } else {
      api.reload('cbda3d7e', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=cbda3d7e&", function () {
      api.rerender('cbda3d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23Q6IZHfpWu1g/JS/comp/IncreaseNumber.vue"
export default component.exports